var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"outlined":"","locale":"jp-ja","elevation":"2","full-width":"","no-title":"","day-format":(date) => new Date(date).getDate()},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }